import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContentContainer = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	padding: 80px;
	display: flex;
`;

const StyledBottomCaptionContainer = styled.div`
	position: absolute;
	left: 0;
	bottom: 80px;
	width: 100%;
	padding: 0 80px;

	${Text} {
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

export { StyledContentContainer, StyledBottomCaptionContainer };
